module.exports = __webpack_public_path__ + "static/finding-my-voice-92ae7bc601b92f9023ca88f6fe9c2002.jpg";